import React from 'react';
import { Grid } from '@mui/material';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import CardWrapper from 'components/Financial/CardWrapper';
import { useFormikContext } from 'formik';
import useAddress from 'hooks/useAddress';
import AutoCompleteContext from 'components/CustomInputsInFormikContext/AutoComplete';
import maskPhone from 'components/Masks/maskPhone';
import { labelField } from 'utils';

function Address({ recoverState }) {
  const { setFieldValue } = useFormikContext();

  const {
    states,
    selectedState,
    handleStateSelect,
    cities,
    selectedCity,
    handleCitySelect,
    loadingStates,
  } = useAddress({ setFieldValue, recoverState });

  return (
    <CardWrapper title="Endereço">
      <Grid item xs={12} md={6} lg={9}>
        <TextFieldContext
          name="street"
          label={labelField('Rua')}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <TextFieldContext
          name="number"
          label={labelField('Número')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <AutoCompleteContext
          disabled={loadingStates}
          noOptionsText="Sem opções"
          autoComplete={false}
          name="uf"
          label={labelField('Estado')}
          options={states}
          value={selectedState}
          getOptionLabel={(options) => options.nome || selectedState}
          onChangeCallback={(value) => {
            handleStateSelect(value);
          }}
          disableClearable
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <AutoCompleteContext
          disabled={loadingStates}
          noOptionsText="Sem opções"
          autoComplete={false}
          label={labelField('Cidade')}
          name="city"
          options={cities}
          value={selectedCity}
          getOptionLabel={(options) => options.nome || selectedCity}
          onChangeCallback={(value) => {
            handleCitySelect(value);
          }}
          disableClearable
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          id="phone"
          label={labelField('Telefone')}
          name="phone"
          type="text"
          InputProps={{
            inputComponent: maskPhone,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <TextFieldContext
          id="descricao"
          name="observation"
          label="Descrição (Opcional)"
        />
      </Grid>
    </CardWrapper>
  );
}

export default Address;
